import * as React from 'react'
import { History, Location } from 'history'
import { compose } from 'react-apollo'
import { connect } from 'react-redux'
import { ApolloError } from 'apollo-client'
import { Dispatch } from 'redux'
import { NewProjectDialog, ProjectThumb } from './index'
import { setTabulationLock } from '../../actions/tabulation'
import { Store } from '../../reducers'
import { Action } from '../../actions/types'

import {
  SpinnerDiv,
  NormalMain,
  MainHeader,
  ProjectTools,
  ProjectWorkArea,
  ProjectListArea,
  NoProjectsMsg,
  NoProjectsTitle,
  NoProjectsView,
  NoProjectsContent,
  ToolTitle,
  NormalButton,
  ViewSection
} from './Styles'

import {
  getProjects as getProjectsQuery,
  ProjectsProps,
  ProjectType,
  ProjectsResult
} from './projectQueries'

type InputProps = {
  loading: boolean
  error?: ApolloError
  getProjects: ProjectsResult
  history: History
  location: Location
  tabulationLocked: boolean
  setTabLock: (lock: boolean) => Action
}

type State = {
  newProject: boolean
}

type WrappedProps = ProjectsProps & InputProps

class ProjectListView extends React.Component<WrappedProps, State> {
  constructor(props: WrappedProps) {
    super(props)
    this.state = { newProject: false }
  }

  render() {
    const { loading, error, getProjects = [], history } = this.props
    return (
      <NormalMain className={'page-main'}>
        <SpinnerDiv>
          {loading && <div className="spinner" />}
          <ProjectTools>
            <div
              style={{
                marginTop: '-25px',
                position: 'absolute',
                cursor: 'pointer'
              }}
              onClick={() => history.goBack()}
            >
              <span>{'<'}</span>
              <span style={{ paddingLeft: '10px' }}>Back</span>
            </div>
            <MainHeader>Project manager</MainHeader>
            <NormalButton
              type={'button'}
              onClick={() => this.setState({ newProject: true })}
            >
              + Create new project
            </NormalButton>
          </ProjectTools>
          <ViewSection key={'MyProjects'}>
            <ToolTitle>My projects</ToolTitle>
            <ProjectWorkArea>
              <ProjectListArea>
                {getProjects.map((project: ProjectType, indx) => (
                  <ProjectThumb
                    key={indx}
                    project={project}
                    history={history}
                  />
                ))}
              </ProjectListArea>
              {error && (
                <NoProjectsMsg>
                  Error loading projects. Try refreshing your browser.
                  {/* refetch seems to be broken in Apollo 2.0.x. We should remove the "please
                      refresh" suggestion and uncomment this once we're in 2.1.x:
                   <button onClick={() => refetch()}>Try again</button> */}
                </NoProjectsMsg>
              )}
              {getProjects.length === 0 &&
                !loading &&
                !error && (
                  <NoProjectsView>
                    <NoProjectsContent>
                      <NoProjectsTitle>
                        You don't have any projects yet, why not create one?
                      </NoProjectsTitle>
                      <NormalButton
                        type={'button'}
                        className={'new-project-button'}
                        onClick={() => this.setState({ newProject: true })}
                      >
                        + Create new project
                      </NormalButton>
                    </NoProjectsContent>
                  </NoProjectsView>
                )}
            </ProjectWorkArea>
          </ViewSection>
          <NewProjectDialog
            isOpen={this.state.newProject}
            closeDialog={() => this.setState({ newProject: false })}
          />
        </SpinnerDiv>
      </NormalMain>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  tabulationLocked: state.tabulation.locked
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  setTabLock: lock => dispatch(setTabulationLock(lock))
})

export default compose(
  getProjectsQuery<InputProps>(),
  connect(mapStateToProps, mapDispatchToProps)
)(ProjectListView)



// WEBPACK FOOTER //
// ./src/Components/Projects/ProjectList.tsx